export abstract class ModelBase {
    status: string;
    mensagem: string;
}